import usePrevious from './usePrevious';

const useIsForceRefetchChanged = forceRefetch => {
    const previousForceRefetch = usePrevious(forceRefetch, false);

    return forceRefetch !== previousForceRefetch;
};

export default useIsForceRefetchChanged;